/* eslint-disable jsx-a11y/anchor-is-valid */
import { useNavigate } from "react-router-dom";
import { Button, IconButton, MenuItem, Select } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import StorageOutlinedIcon from "@mui/icons-material/StorageOutlined";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import RemoveCircleOutlineOutlinedIcon from "@mui/icons-material/RemoveCircleOutlineOutlined";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";

import { useState } from "react";
import SearchBar from "../../../components/SearchBar";
import AddDPA from "../../../Modals/addDPA";

const RiskRegistry = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const policies = [
        {
            title: "Ransomware Attack",
            code: "RISK-005",
            description: "Risk of ransomware infection affecting critical systems",
            owner: "Owner: Michael Roberts",
            version: "Security",
            effective: "L3 × I5 = 15",
            status: "Critical",
            review: "Mitigating",
            icon: <ReportProblemOutlinedIcon />
        },
        {
            title: "Third-Party Data Breach",
            code: "RISK-001",
            description: "Risk of customer data exposure through compromised vendor",
            owner: "Owner: Michael Roberts",
            version: "Security",
            effective: "L3 × I5 = 15",
            status: "High",
            review: "Mitigating",
            icon: <ReportProblemOutlinedIcon />
        },
        {
            title: "API Security Vulnerability",
            code: "RISK-006",
            description: "Risk of data exposure through API security flaws",
            owner: "Owner: Alex Kumar",
            version: "Security",
            effective: "L3 × I4 = 12",
            status: "High",
            review: "Mitigating",
            icon: <ReportProblemOutlinedIcon />
        },
        {
            title: "Regulatory Non-Compliance",
            code: "RISK-002",
            description: "Risk of fines due to evolving data protection regulations",
            owner: "Owner: Sarah Chen",
            version: "Legal",
            effective: "L2 × I5 = 10",
            status: "High",
            review: "Mitigating",
            icon: <BusinessOutlinedIcon />
        },
        {
            title: "Business Continuity Failure",
            code: "RISK-004",
            description: "Risk of extended service outage impacting customers",
            owner: "Owner: David Wilson",
            version: "Operational",
            effective: "L2 × I4 = 8",
            status: "Medium",
            review: "Assessed",
            icon: <TrendingUpOutlinedIcon />
        },
        {
            title: "Insider Threat",
            code: "RISK-003",
            description: "Risk of malicious or negligent employee actions",
            owner: "Owner: Emma Thompson",
            version: "Security",
            effective: "L2 × I4 = 8",
            status: "Medium",
            review: "Mitigating",
            icon: <GroupOutlinedIcon />
        }
    ];


    const [openModal, setOpenModal] = useState(false);
    const handleCloseModal = () => {
        setOpenModal(false);
    };
    return (
        <>
            {/* ===== Page Title ===== */}
            <div className="main_title d_flex">
                <div className="left_s">
                    <h1>Risk Registry</h1>
                </div>

                <div className="right_s">
                    <Button
                        className="btn btn_primary"
                        onClick={() => setOpenModal(true)}
                    >
                        <AddIcon /> Add Risk
                    </Button>
                </div>
            </div>

            {/* ===== Stats Overview (KEEP YOUR DESIGN) ===== */}

            {/* ======= Stats Overview ======= */}
            <div className="stats_boxes gap_m">

                {/* Total Risks */}
                <a className="cards compact">
                    <div className="data_top">
                        <figure className="blue">
                            <ReportProblemOutlinedIcon />
                        </figure>

                        <div className="meta">
                            <h2>7</h2>
                            <p>Total Risks</p>
                        </div>
                    </div>
                </a>

                {/* Admin Risk */}
                <a className="cards compact">
                    <div className="data_top">
                        <figure className="danger">
                            <ErrorOutlineOutlinedIcon />
                        </figure>

                        <div className="meta">
                            <h2>1</h2>
                            <p>Admin Risk</p>
                        </div>
                    </div>
                </a>

                {/* User Risk */}
                <a className="cards compact">
                    <div className="data_top">
                        <figure className="warning">
                            <TrendingUpOutlinedIcon />
                        </figure>

                        <div className="meta">
                            <h2>3</h2>
                            <p>User Risk</p>
                        </div>
                    </div>
                </a>

                {/* Vendor Risk */}
                <a className="cards compact">
                    <div className="data_top">
                        <figure className="info">
                            <RemoveCircleOutlineOutlinedIcon />
                        </figure>

                        <div className="meta">
                            <h2>3</h2>
                            <p>Vendor Risk</p>
                        </div>
                    </div>
                </a>

                {/* Service Provider Risk */}
                <a className="cards compact">
                    <div className="data_top">
                        <figure className="sucess">
                            <CheckCircleOutlineOutlinedIcon />
                        </figure>

                        <div className="meta">
                            <h2>0</h2>
                            <p>Service Provider Risk</p>
                        </div>
                    </div>
                </a>

            </div>


            {/* ===== Search Header (AS REQUESTED) ===== */}
            <div className="cards mt_20">
                <div className="table_header">
                    <div className="left_s">
                        <SearchBar
                            searchTerm={searchTerm}
                            setDebouncedSearchTerm={setSearchTerm}
                            placeholder="Search policies..."
                        />
                    </div>

                  
                </div>

                {/* ===== Policy List ===== */}
                <div className="policies_div mt_20">
                    {policies.map((policy, i) => (
                        <div className="policy_row" key={i}>
                            <div className="left">
                                <div className="policy_icon">
                                    {policy.icon}
                                </div>

                                <div className="policy_info">
                                    <div className="title_row">
                                        <b>{policy.title}</b>
                                        <span className="code">{policy.code}</span>

                                        <span className="status_chip active">
                                            {policy.status}
                                        </span>

                                        <span className="status_chip danger">
                                            {policy.review}
                                        </span>
                                    </div>

                                    <p>{policy.description}</p>

                                    <small>
                                        {policy.owner} · {policy.version} · Effective: {policy.effective}
                                    </small>
                                </div>
                            </div>

                            <div className="actions">
                                <IconButton><DeleteOutlineOutlinedIcon /></IconButton>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <AddDPA
                open={openModal}
                onClose={handleCloseModal}
                setOpen={setOpenModal}
            />
        </>
    );
};

export default RiskRegistry;
